import { createContext, useCallback, useContext, useState } from 'react'

type CmdKContext = {
  open: boolean
  openCommandKBar: () => void
  closeCommandKBar: () => void
}

const CommandKBarContext = createContext<CmdKContext>(null)

type Props = {
  children: React.ReactNode
}

export const CommandKBarProvider: React.FC<Props> = ({ children }) => {
  const [open, setOpen] = useState(false)

  const openCommandKBar = useCallback(() => setOpen(true), [])
  const closeCommandKBar = useCallback(() => setOpen(false), [])

  return (
    <CommandKBarContext.Provider
      value={{
        open,
        openCommandKBar,
        closeCommandKBar,
      }}
    >
      {children}
    </CommandKBarContext.Provider>
  )
}

export const useCommandKBar = () => useContext(CommandKBarContext)
